/**
 * map opportunity type to text in pt
 * @param type
 * @returns
 */
export function mapOpportunityTypeToText(type) {
    if (type === 'CREDIT_CARD') {
        return 'Cartão de crédito';
    }
    if (type === 'PERSONAL_LOAN') {
        return 'Crédito pessoal';
    }
    if (type === 'BUSINESS_LOAN') {
        return 'Crédito empresarial';
    }
    if (type === 'MORTGAGE_LOAN') {
        return 'Financiamento imobiliário';
    }
    if (type === 'VEHICLE_LOAN') {
        return 'Financiamento automotivo';
    }
    if (type === 'OVERDRAFT') {
        return 'Cheque especial';
    }
    if (type === 'OTHER_LOAN') {
        return 'Outros tipos de crédito';
    }
    // OTHER
    return 'Outros';
}
